// Changing this file can affect sportsbook favorites functionality

export const events = {
  event: [
    'name',
    'id',
    'price',
    'base',
    'order',
    'type_1',
    'extra_info',
    'display_column'
  ]
};

export const markets = {
  market: [
    'name',
    'order',
    'type',
    'id',
    'base',
    'express_id',
    'col_count',
    'express_id',
    'group_id',
    'group_name',
    'cashout',
    'display_key'
  ]
};

export const marketsEuropean = {
  market: [
    'id',
    'name',
    'type',
    'order',
    'main_order',
    'cashout',
    'col_count',
    'display_key',
    'display_sub_key',
    'market_type',
    'name_template',
    'point_sequence',
    'sequence',
    'extra_info',
    'express_id'
  ]
};

export const sports = {
  sport: ['name', 'alias', 'id']
};

export const regions = {
  region: ['name', 'alias', 'order', 'id']
};

export const competitions = {
  competition: ['name', 'order', 'id']
};

export const gameList = {
  game: [
    [
      'id',
      'type',
      'team1_name',
      'team2_name',
      'team1_id',
      'team2_id',
      'order',
      'start_ts',
      'markets_count',
      'is_blocked',
      'info',
      'tv_type',
      'exclude_ids',
      'show_type',
      'text_info',
      'add_info_name',
      'tv_info',
      'is_stat_available',
      'video_id',
      'video_id2',
      'video_id3',
      'sportcast_id',
      'match_length',
      'live_events'
    ]
  ]
};

export const marketWhereGameList = {
  market: {
    display_key: 'WINNER',
    display_sub_key: 'MATCH'
  }
};

export const marketWhereEuropean = {
  market: {
    display_key: {
      '@in': ['WINNER', 'HANDICAP', 'TOTALS']
    },
    display_sub_key: {
      '@in': ['MATCH', 'PERIOD']
    }
  }
};
